import { combineReducers } from 'redux';
import uiTheme from './themeReducer'
import masterdataReducer from './masterdata'

export default combineReducers({
  uiTheme,
  masterdataReducer,
});
